<template>
  <div>
    <ul class="msgTool">
      <li v-for="(item, index) in items" :key="index">
        <Input placeholder="请输入" v-model="items[index]"></Input
        ><Button size='small' @click="add(index)" icon="md-add"></Button
        ><Button @click="del(index)" icon="md-close"></Button>
      </li>
    </ul>

    <Button size='small' v-if="items.length==0" @click="add(0)" type="primary">添加</Button>
    <Button size='small' v-if="false" @click="items.splice(0, items.length)" type="error">清空</Button>
    <Drawer
      v-if="isUser"
      title="选择用户"
      class="my-drawer"
      v-model="openDrawer"
    >
      <user-tree @user="reUser" @orgin="match"></user-tree>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["items", "isUser"],
  data() {
    return {
      //items: [11111, 22222, 3333, 44444],
      openDrawer: false,
    };
  },
  methods: {
    add(index) {
      if (this.isUser) {
        this.openDrawer = true;
      } else {
        var aarr = this.items;
        aarr.splice(index, 0, "");
      }
    },
    del(index) {
      var aarr = this.items;
      aarr.splice(index, 1);
    },
    reUser(v) {
      console.log(v);
    },
    match(v) {
      var t = this.items;
      var t = ["1726413332650713090", "1725359890733785089"];
      var m=[];
      for (let i = 0; i < v.length; i++) {
        for (let j = 0; j < t.length; j++) {
          if (v[i].accountId == t[j]) {
            m.push(v[i])
          }
        }
      }
      
    },
  },
  model: {
    prop: "items",
    event: "abc",
  },
};
</script>
<style>
.msgTool {
  display: flex;
  display: flex;
  flex-wrap: wrap;
  border: solid 1px #ccc;
  padding: 4px;
  width: 100%;
  max-height: 200px;
  overflow: auto;
}
.msgTool li {
  display: flex;
  width: calc(100% - 10px);
  margin-right: 10px;
  margin-bottom: 10px;
  float: left;
}
</style>


// WEBPACK FOOTER //
// src/components/rule/msgtool.vue